import React from 'react'

const AOI = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 1L2 5.44v13.12L12 23l10-4.44V5.44L12 1zm0 2.06L20.47 6v11.49L12 20.94 3.53 17.5V6L12 3.06zM12 5v14.89l6.6-2.93L12 19.77l-6.6-2.81L12 5z"
      />
    </svg>
  )
}

export default AOI
